<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group>
          <b-button variant="outline-primary">
            <input
              type="checkbox"
              v-model="selectAll"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-primary"
            class="btn-icon"
            :disabled="recordIds.length == 0"
            @click="multiDelete"
            v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
          >
            <feather-icon icon="Trash2Icon" />
            <!-- {{ $t("site.bulk_delete") }} -->
          </b-button>
          <b-button
            variant="outline-primary"
            class="btn-icon"
            :class="{ active: itemView == 'DataTable' }"
            @click="setItemView('DataTable')"
          >
            <feather-icon icon="ServerIcon" />
          </b-button>

          <b-button
            variant="outline-primary"
            class="btn-icon"
            :class="{ active: itemView == 'grid-view' }"
            @click="setItemView('grid-view')"
          >
            <feather-icon icon="GridIcon" />
          </b-button>
        </b-button-group>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input
            v-model="search"
            type="text"
            autofocus
            class="form-control"
            :placeholder="$t(`site.search`)"
            @input="(val) => searchChange(val)"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [6, 12, 24, 60, 120]"
              :key="index"
              @click="changePageSize(size)"
            >
              {{ size }}
            </b-dropdown-item>
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto" v-if="itemView == 'DataTable'">
        <b-card>
          <b-table
            :stacked="$mobile == 1"
            ref="table"
            class="vuetable"
            sort-by="id"
            :current-page="currentPage"
            :fields="bootstrapTable.fields"
            :items="dataProvider"
          >
            <template #cell(assign)="data">
              <b-button
                v-if="data.item.teachers.length > 0"
                class="btn-wishlist"
                variant="outline-success"
                v-b-modal.modal-info
                @click="
                  openAssign(data.item, 'teacher', 'عرض اعضاء هيئة التدريس ')
                "
              >
                اعضاء هيئة التدريس
              </b-button>
              <b-button
                v-else
                class="btn-wishlist"
                variant="outline-danger"
                v-b-modal.modal-info
                @click="openAssign(data.item, 'teacher', '')"
              >
                تعيين عضو هيئة تدريس
              </b-button>
            </template>
            <template #cell(users)="data">
              <b-button
                class="btn-wishlist"
                variant="outline-success"
                v-b-modal.modal-user
                @click="openUsers(data.item)"
              >
                عرض المشتركين
              </b-button>
            </template>
            <template #cell(quran_program)="data">
              {{ data.item.quran_program.title }}
            </template>
            <template #cell(checkbox)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
                <input
                  v-model="recordIds"
                  type="checkbox"
                  :value="data.item.id"
                  @change="selectItem(data)"
                />
                <span />
              </label>
            </template>
            <template #cell(type)="data">
              {{ $t("quran_programs." + data.item.type) }}
            </template>
            <template #cell(edit)="data">
              <b-dropdown :text="$t('site.action')" variant="flat-primary">
                <b-dropdown-item @click="openLive(data.item)">
                  <i
                    class="fas fa-door-open"
                    style="display: inline-block; margin: ; padding: 1px 5px"
                  ></i>
                  <span class="text-warning">دخول </span>
                </b-dropdown-item>
                <b-dropdown-item v-if="$role != 'student'">
                  <a
                    style="padding: 5px; cursor: pointer"
                    class="dropdown-item get-online-session-links"
                    @click="end(data.item)"
                  >
                    <i
                      class="fas fa-stop-circle"
                      style="display: inline-block; margin: 0; padding: 1px 5px"
                    ></i>
                    <span
                      class="text-danger"
                      style="display: inline-block; margin: 0; padding: 1px 5px"
                    >
                      إنهاء الاجتماع</span
                    >
                  </a>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="data.item.online_session"
                  :to="{
                    name: 'OnlineDetails',
                    params: {
                      id: data.item.online_session.id,
                    },
                  }"
                >
                  <a
                    style="padding: 5px; cursor: pointer"
                    class="dropdown-item get-online-session-links"
                  >
                    <i
                      class="fas fa-photo-video"
                      style="display: inline-block; margin: 0; padding: 1px 5px"
                    ></i>
                    <span
                      class="text-info"
                      style="display: inline-block; margin: 0; padding: 1px 5px"
                    >
                      تحميل ملف الفيديو</span
                    >
                  </a>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="$role != 'student'"
                  :to="{
                    name: 'SessionAttendance',
                    params: {
                      session_room_id: 0,
                      session_id: data.item.id,
                    },
                  }"
                >
                  <a
                    style="padding: 5px; cursor: pointer"
                    class="dropdown-item get-online-session-links"
                  >
                    <i
                      class="fas fa-clipboard-check"
                      style="display: inline-block; margin: 0; padding: 1px 5px"
                    ></i>
                    <span
                      class="text-info"
                      style="display: inline-block; margin: 0; padding: 1px 5px"
                    >
                      {{ $t("attendance.attendance_record") }}</span
                    >
                  </a>
                </b-dropdown-item>

                <!-- <b-dropdown-item v-if="!checkApologies(data.item)" v-b-modal.modal-excuse variant="outline-info"
                  @click="onlineSessionId = data.item.online_session.id">
                  {{ $t("attendance.ask_for_excuse") }}
                </b-dropdown-item> -->
                <!-- <b-dropdown-item @click="getApologies(data.item)" variant="outline-primary" v-else>
                  {{ $t("site.read") }}
                </b-dropdown-item> -->
                <b-dropdown-item
                  v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                  @click="editItem(data)"
                  variant="warning"
                >
                  <i class="fa fa-edit"></i>
                  {{ $t("site.edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="deleteItem(data)"
                  v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                  variant="danger"
                >
                  <i class="fa fa-trash"></i>
                  {{ $t("site.delete") }}
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>
      </div>

      <div
        v-if="itemView == 'grid-view' && !load"
        :class="itemView"
        id="nav-group"
        class="col-lg-12"
        role="tabpanel"
        aria-labelledby="nav-group-tab"
      >
        <b-col lg="12">
          <b-row>
            <b-col md="4" v-for="item in data" :key="item.id">
              <b-card class="text-center">
                <b-card-text>
                  <b-media no-body>
                    <b-media-aside class="mr-1">
                      <b-avatar rounded variant="light-primary" size="34">
                        <feather-icon icon="MicIcon" size="18" />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6 class="mb-0">التاريخ</h6>
                      <small> {{ item.date }}</small>
                    </b-media-body>
                    <b-media-body>
                      <h6 class="mb-0">الساعة</h6>
                      <small> {{ item.start }}</small>
                    </b-media-body>
                    <b-media-body>
                      <h6 class="mb-0">{{ $t("quran_programs.alward") }}</h6>
                      <small> {{ item.alward }}</small>
                    </b-media-body>
                  </b-media>
                  <br />
                  <template
                    v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                  >
                    <b-button
                      v-if="item.teachers.length > 0"
                      class="col-12"
                      variant="success"
                      v-b-modal.modal-info
                      @click="
                        openAssign(item, 'teacher', 'عرض اعضاء هيئة التدريس ')
                      "
                    >
                      اعضاء هيئة التدريس
                    </b-button>
                    <b-button
                      v-else
                      class="col-12"
                      variant="danger"
                      v-b-modal.modal-info
                      @click="openAssign(item, 'teacher', '')"
                    >
                      تعيين عضو هيئة تدريس
                    </b-button>
                  </template>

                  <b-button
                    class="col-12 mt-1"
                    variant="success"
                    v-b-modal.modal-user
                    @click="openUsers(item)"
                  >
                    عرض المشتركين
                  </b-button>
                  <b-dropdown
                    :text="$t('site.action')"
                    variant="flat-primary"
                    class="col-12 mt-1"
                  >
                    <b-dropdown-item @click="openLive(item)">
                      <i
                        class="fas fa-door-open"
                        style="
                          display: inline-block;
                          margin: ;
                          padding: 1px 5px;
                        "
                      ></i>
                      <span class="text-warning">دخول </span>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="$role != 'student'">
                      <a
                        style="padding: 5px; cursor: pointer"
                        class="dropdown-item get-online-session-links"
                        @click="end(item)"
                      >
                        <i
                          class="fas fa-stop-circle"
                          style="
                            display: inline-block;
                            margin: 0;
                            padding: 1px 5px;
                          "
                        ></i>
                        <span
                          class="text-danger"
                          style="
                            display: inline-block;
                            margin: 0;
                            padding: 1px 5px;
                          "
                        >
                          إنهاء الاجتماع</span
                        >
                      </a>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="item.online_session"
                      :to="{
                        name: 'OnlineDetails',
                        params: {
                          id: item.online_session.id,
                        },
                      }"
                    >
                      <a
                        style="padding: 5px; cursor: pointer"
                        class="dropdown-item get-online-session-links"
                      >
                        <i
                          class="fas fa-photo-video"
                          style="
                            display: inline-block;
                            margin: 0;
                            padding: 1px 5px;
                          "
                        ></i>
                        <span
                          class="text-info"
                          style="
                            display: inline-block;
                            margin: 0;
                            padding: 1px 5px;
                          "
                        >
                          تحميل ملف الفيديو</span
                        >
                      </a>
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="
                        $role != 'student' && item.quran_program.attendance == 1
                      "
                      :to="{
                        name: 'SessionAttendance',
                        params: {
                          session_room_id: 0,
                          session_id: item.id,
                        },
                      }"
                    >
                      <a
                        style="padding: 5px; cursor: pointer"
                        class="dropdown-item get-online-session-links"
                      >
                        <i
                          class="fas fa-clipboard-check"
                          style="
                            display: inline-block;
                            margin: 0;
                            padding: 1px 5px;
                          "
                        ></i>
                        <span
                          class="text-info"
                          style="
                            display: inline-block;
                            margin: 0;
                            padding: 1px 5px;
                          "
                        >
                          {{ $t("attendance.attendance_record") }}</span
                        >
                      </a>
                    </b-dropdown-item>

                    <!-- <b-dropdown-item v-if="!checkApologies(item)" v-b-modal.modal-excuse variant="outline-info"
                  @click="onlineSessionId = item.online_session.id">
                  {{ $t("attendance.ask_for_excuse") }}
                </b-dropdown-item> -->
                    <!-- <b-dropdown-item @click="getApologies(item)" variant="outline-primary" v-else>
                  {{ $t("site.read") }}
                </b-dropdown-item> -->
                    <b-dropdown-item
                      v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                      @click="editItem(data)"
                      variant="warning"
                    >
                      <i class="fa fa-edit"></i>
                      {{ $t("site.edit") }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="deleteItem(data)"
                      v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                      variant="danger"
                    >
                      <i class="fa fa-trash"></i>
                      {{ $t("site.delete") }}
                    </b-dropdown-item>
                  </b-dropdown>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </div>
      <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />

      <hr />
      <b-pagination
        v-model="currentPage"
        align="right"
        class="dataTables_paginate paging_simple_numbers pagination-warning"
        :total-rows="totalRows"
        :per-page="perPage"
        @input="onChangePage(currentPage)"
      >
        <template v-slot:next-text>
          <i class="fas fa-angle-left" />
        </template>
        <template v-slot:prev-text>
          <i class="fas fa-angle-right" />
        </template>
        <template v-slot:first-text>
          <i class="fas fa-step-forward" />
        </template>
        <template v-slot:last-text>
          <i class="fas fa-step-backward" />
        </template>
      </b-pagination>
    </div>

    <b-modal
      id="modal-user"
      ok-variant="info"
      ok-title="ok"
      modal-class="modal-info"
      centered
      size="lg"
      :title="title"
    >
      <b-table :stacked="$mobile == 1" :items="stUsers" :fields="userfields">
        <template #cell(checkbox)="data"> # </template>
      </b-table>

      <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
    </b-modal>
    <b-modal
      id="modal-info"
      ok-variant="info"
      ok-title="save"
      modal-class="modal-info"
      centered
      @ok="save"
      size="lg"
      :title="title"
    >
      <b-table :stacked="$mobile == 1" :items="users" :fields="userfields">
        <template #cell(checkbox)="data">
          <b-form-checkbox
            v-model="usersSelelcted"
            :value="data.item.id"
            v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
          >
          </b-form-checkbox>
        </template>
      </b-table>

      <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
    </b-modal>
    <b-modal
      id="modal-excuse"
      ok-variant="info"
      :ok-title="$t('site.add')"
      :cancel-title="$t('site.cancel')"
      :ok-disabled="invalid"
      modal-class="modal-info"
      centered
      @ok="submit"
      size="lg"
      :title="$t('attendance.ask_for_excuse')"
    >
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                :name="$t('apology.reason')"
                vid="reason"
                rules="required"
              >
                <b-form-group class="mb-2">
                  <ckeditor
                    :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                    v-model="newData.reason"
                    :placeholder="$t('apology.reason')"
                    :state="errors.length > 0 ? false : null"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
    <b-modal
      ref="modal-primary"
      ok-only
      ok-title="ok"
      size="lg"
      modal-class="modal-primary"
      centered
    >
      <b-card-text>
        <b-spinner
          v-if="loadStatus"
          type="grow"
          label="Loading..."
          class="loading"
        />
        <b-row>
          <b-col lg="12">
            <app-timeline>
              <app-timeline-item
                v-for="status in apologyStatus"
                :key="status.id"
                :title="status.status"
                :subtitle="status.reason"
                :time="status.created_at.split('T')[0]"
              />
            </app-timeline>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import OnlineSessionController from "@/Controllers/OnlineSessionController";
import controller from "@/Controllers/QuranScheduleDateController";
import UsersController from "@/Controllers/UsersController";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ApologyController from "@/Controllers/ApologyController";
import ApologyStatusController from "@/Controllers/ApologyStatusController";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Auth from "@/Apis/Auth";
const apologyController = new ApologyController();
export default {
  components: {
    required,
    ValidationProvider,
    ValidationObserver,
    AppTimeline,
    AppTimelineItem,
  },
  props: ["items", "editItem", "code"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "code",
            label: this.$i18n.t("site.code"),
            sortable: true,
          },
          {
            key: "name",
            label: this.$i18n.t("quran_programs.date_name"),
            sortable: true,
          },

          {
            key: "type",
            label: this.$i18n.t("quran_programs.program_type"),
            sortable: true,
          },
          {
            key: "alward",
            label: this.$i18n.t("quran_programs.alward"),
            sortable: true,
          },
          {
            key: "date",
            label: this.$i18n.t("quran_programs.room_date"),
            sortable: true,
          },
          {
            key: "start",
            label: this.$i18n.t("quran_programs.start_at"),
            sortable: true,
          },
          {
            key: "end",
            label: this.$i18n.t("quran_programs.end_at"),
            sortable: true,
          },
          {
            key: "users",
            label: this.$i18n.t("quran_programs.students"),
            // sortable: true,
          },
          {
            key: "assign",
            label: this.$i18n.t("quran_programs.assign_teacher"),
            // sortable: true,
          },

          //
          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      itemView: "DataTable",
      data: {},
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 6,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      programSelelcted: {},
      usersSelelcted: [],
      users: [],
      stUsers: [],
      userfields: [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
        },
        {
          key: "first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
        },
        {
          key: "last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
        },

        {
          key: "email",
          label: this.$i18n.t("users.email"),
          sortable: true,
        },
      ],
      loadStatus: false,
      onlineSessionId: 0,
      apologySelsct: {},
      title: "",
      newData: {},
      apologyStatus: [],
      invalid: false,
    };
  },
  async created() {
    if (this.$role != "super_admin" || this.$role != "QuranAdmin") {
      this.bootstrapTable.fields.splice(9, 1);
    }
    const itemViewOptions = [
      { icon: "GridIcon", value: "grid-view" },
      { icon: "ListIcon", value: "list-view" },
    ];
    let itemView = localStorage.getItem("itemView");
    if (!itemView) {
      itemView = "DataTable";
    }
    await this.dataProvider(this.params);
    this.itemView = itemView;
    this.users = await new UsersController().GetAll({
      type: "teacher",
      filter: "quran_program_supervise|1",
    });
  },
  methods: {
    async getApologies(item) {
      this.loadStatus = true;
      this.apologyStatus = [];
      this.$refs["modal-primary"].show();

      this.apologySelsct = item.online_session.apology;
      this.apologyStatus = await new ApologyStatusController().GetAll({
        filter: "apology_id|" + this.apologySelsct.id,
      });
      this.loadStatus = false;
    },
    checkApologies(item) {
      if (item.online_session.apology == null) return false;

      if (
        item.online_session.apology.apologytable_id == item.online_session.id &&
        item.online_session.apology.user_id == Auth.USER.id
      )
        return true;
      return false;
    },
    checkAskForExcuse(item) {
      const find = item.apology.find((a) => a.user_id == item.id);
      if (find) {
        return true;
      }
      return false;
    },
    async submit() {
      this.newData.apologytable_id = this.onlineSessionId;
      this.newData.apologytable_type = "App\\OnlineClass";
      this.newData.user_id = Auth.USER.id;
      console.log(this.newData);
      const ap = await apologyController.From(this.newData);
      this.dataProvider(this.params);
    },
    async submitStatus() {
      this.newData.user_id = Auth.USER.id;
      this.newData.apology_user_id = this.apologySelsct.user_id;
      this.newData.apology_id = this.apologySelsct.id;
      this.newData.online_session_id = this.apologySelsct.apologytable_id;

      const ap = await new ApologyStatusController().From(this.newData);
      this.$refs["modal-primary"].hide();
      this.dataProvider(this.params);
    },
    checkUserSession(item) {
      const find = item.user_sessions.find(
        (a) => a.online_session_id == this.session_id
      );
      if (find) return true;
      return false;
    },
    checkExcuse(item) {
      const find = item.user_sessions.find(
        (a) => a.online_session_id == this.session_id
      );
      if (!find) return false;
      if (find.excuse_id !== null) return true;
      return false;
    },
    openLive(data) {
      console.log(data);
      new OnlineSessionController().joinLecture(data.onlline_class_id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      console.log(this.currentPage);
      this.params.currentPage = this.currentPage;
      if (this.$refs.table) this.$refs.table.refresh();
      this.dataProvider(this.params);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      console.log(this.$parent.$parent.$parent.code);
      this.$parent.$parent.$parent.code = 2000 + data.total + 1;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.with = ["teachers", "students", "quranProgram"];
      // apiParams.with = [, "students"];
      //      apiParams.with = ["UserSessions", "apology"];
      if (this.$route.name == "QuranScheduleDateNow") {
        apiParams.now = 1;

        this.bootstrapTable.fields.splice(3, 0, {
          key: "quran_program",
          label: this.$i18n.t("quran_programs.quran_programs"),
          sortable: false,
        });
      } else {
        apiParams.filter = "quran_program_id|" + this.$route.params.id;
      }
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.$refs.table.refresh();
      this.dataProvider(this.params);
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
    async save() {
      if (this.$role != "super_admin" || this.$role == "QuranAdmin") return;
      this.load = true;
      this.studentsLoad = true;
      await new controller().assignTeacherDate(this.programSelelcted.id, {
        teacher_ids: this.usersSelelcted,
      });
      this.studentsLoad = false;
      this.usersSelelcted = [];
      this.programSelelcted = {};
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    async openUsers(item) {
      this.studentsLoad = true;
      this.stUsers = item.students;

      this.studentsLoad = false;
    },
    async openAssign(item, type, title) {
      this.title = title;
      this.programSelelcted = item;

      this.studentsLoad = true;
      this.usersSelelcted = item.teachers.map((x) => x.id);

      this.studentsLoad = false;
    },
    setItemView(view) {
      localStorage.setItem("itemView", view);
      this.itemView = view;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/base/pages/app-ecommerce.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
